// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__3X-WH","savePackageButton":"ClientWallet_savePackageButton__1DA_j"};